var _style, _line, _line2, _line3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBurgerIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 28.81 20.23",
    style: {
      enableBackground: "new 0 0 28.81 20.23"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#5CCCFF;}\n\t.st1{fill:#5DCCFF;}\n\t.st2{fill:#1D1D1B;}\n\t.st3{fill:#1E1E1C;}\n\t.st4{clip-path:url(#SVGID_2_);}\n\t.st5{clip-path:url(#SVGID_4_);}\n\t.st6{fill:#FFFFFF;}\n\t.st7{fill:none;stroke:#FFFFFF;stroke-width:3;stroke-miterlimit:10;}\n\t.st8{fill:none;stroke:#1D1D1B;stroke-width:3;stroke-miterlimit:10;}\n")), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 0.19,
    y1: 1.68,
    x2: 28.65,
    y2: 1.68
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 0.19,
    y1: 9.86,
    x2: 14.15,
    y2: 9.86
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 0.19,
    y1: 18.55,
    x2: 22.9,
    y2: 18.55
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBurgerIcon);
export default __webpack_public_path__ + "static/media/burger_icon.553c4626da224e92fd6280799400e6bc.svg";
export { ForwardRef as ReactComponent };